// @TODO <HEALTH2019>
App.controller('ZochHealthInsuranceDetailsCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaInsuranceService', '$timeout', '$stateParams', 'Blob', 'FileSaver', '$rootScope', 'zochaHealthInsuranceService', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaInsuranceService, $timeout, $stateParams, Blob, FileSaver, $rootScope, zochaHealthInsuranceService) {
// @TODO </HEALTH2019>
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_healthInsurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Szczegóły deklaracje';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.healthInsurance.list';
    $scope.$emit('link', $scope.link);

    $scope.data = $scope.stateParams.package;
    if (!$scope.data) {
        $state.go('root.home.zoch.healthInsurance.list');
        return;
    }

    if ($scope.data.partner && Object.keys($scope.data.partner).length) {
        $scope.partner_length = true;
    }

    if ($scope.data.children.length) {
        $scope.children_length = true;
    }

    if (typeof $scope.data.rehabilitation !== 'undefined' && $scope.data.rehabilitation) {
        $scope.data.benefit.workerPrice += $scope.data.benefit.rehabilitationPrice;
    }


    $scope.getDeclaration = function(ev, value) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }
        // @TODO <HEALTH2019>

        var id = value.uuid, barcode = value.barcode;

            zochaHealthInsuranceService.getDeclaration(id).then(function (data) {
                if (data.status === 200) {
                    var data = new Blob([data.data], { type: 'application/pdf' });
                    FileSaver.saveAs(data, 'Deklaracja_' + barcode + '.pdf');
                }

                $timeout(function() {
                    $(ev.currentTarget).removeClass('disabled');
                }, 1500);
            });
// @TODO </HEALTH2019>
    };

    $scope.getStatement = function(ev, data) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }

// @TODO <HEALTH2019>
            zochaHealthInsuranceService.getStatement(data.uuid).then(function (data) {
                if (data.status === 200) {
                    var data = new Blob([data.data], { type: 'application/pdf' });
                    FileSaver.saveAs(data, 'oswiadczenie.pdf');
                }

                $timeout(function() {
                    $(ev.currentTarget).removeClass('disabled');
                }, 1500);
            });
// @TODO </HEALTH2019>
    };

    $scope.reason = 'EMPLOYEE_RESIGNATION';

    $scope.withdraw = function(id) {
        var criteria = {
            id: id,
            data: {
                withdrawalReason: $scope.reason
            }
        };

        if ($scope.reason === 'DEATH') {
            criteria.data.dateOfDeath = $scope.dateOfDeath
        }
            zochaHealthInsuranceService.withdraw(criteria).then(function (data) {
                if (data.status === 200) {
                    $state.go('root.home.zoch.healthInsurance.list');
                }
            });
    };

    $scope.redirectToDeclarationById = function(declaration) {
        var replacedBarcode = declaration.replacedByBarcode;
        var replacedDeclarationId = declaration.replacedByHealthInsuranceDeclarationId;
        if (!replacedBarcode || !replacedDeclarationId) {
            return;
        }

        var criteria = {
            pageNumber: 0,
            pageSize: 10,
            search: replacedBarcode
        };

        zochaHealthInsuranceService.dataList(criteria).then(function (data) {
            if (data.status === 200) {
                var response = data.data.data;
                if (response.length === 1) {
                    var _correctDeclaration = response[0];
                    _correctDeclaration.activeStatus = _correctDeclaration.status === 'ACTIVE';
                    if (_correctDeclaration.rehabilitation) {
                        _correctDeclaration.benefit.name += ' + Rehabilitacja';
                        _correctDeclaration.benefit.summaryPrice += _correctDeclaration.benefit.rehabilitationPrice;
                    }
                    $state.go('root.home.zoch.healthInsurance.details', {package: _correctDeclaration});
                } else {
                    for (var i = 0; i < response.length; i++) {
                        var _currentDeclaration = response[i];
                        if (_currentDeclaration.declaration.id === replacedDeclarationId) {
                            _currentDeclaration = _currentDeclaration === 'ACTIVE';
                            if (_currentDeclaration.rehabilitation) {
                                _currentDeclaration.benefit.name += ' + Rehabilitacja';
                                _currentDeclaration.benefit.summaryPrice += _currentDeclaration.benefit.rehabilitationPrice;
                            }
                            $state.go('root.home.zoch.healthInsurance.details', {package: _currentDeclaration});
                        }
                    }
                }
            }
        });
    }
}]);
